Ext.define('SA.model.createimport.ColumnDefinitionList', {
    constructor(columns) {
        this.columns = columns;
    },

    filter(callback) {
        return this.columns.filter(callback);
    },

    getDataColumnDefinitions() {
        return this.filter(column => column.isDataColumn());
    },

    getDefaultedNames() {
        var isDefaultNamed = column => column.isDefaultNamed(),
            getName = column => column.getHeaderName();

        return this.getDataColumnDefinitions().filter(isDefaultNamed).map(getName);
    },

    getFriendlyNames() {
        return this.filter(column => column.isFriendlyNamed()).map(column => column.getFriendlyName());
    },

    getLocationColumnDefinitions() {
        return this.filter(column => column.isLocationColumn());
    },

    serializeForRequest() {
        return this.getDataColumnDefinitions().map(column => column.serializeForRequest());
    },

    serializeForReview() {
        var definitions = [...this.getLocationColumnDefinitions(), ...this.getDataColumnDefinitions()],
            serialize = column => column.serializeForReview();

        return definitions.map(serialize);
    },

    some(callback) {
        return this.columns.some(callback);
    }
});